import React from 'react';
import { Layout, Avatar, Dropdown, Button, Space, Typography } from 'antd';
import { 
  UserOutlined, 
  LogoutOutlined, 
  SettingOutlined,
  BellOutlined 
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

const { Header } = Layout;
const { Text } = Typography;

const Navbar = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: '个人资料',
      onClick: () => navigate('/profile')
    },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: '系统设置'
    },
    {
      type: 'divider'
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout
    }
  ];

  const getRoleText = (role) => {
    const roleMap = {
      admin: '系统管理员',
      manager: '设计主管',
      designer: '设计师',
      pm: '项目经理'
    };
    return roleMap[role] || role;
  };

  return (
    <Header 
      style={{ 
        background: '#fff', 
        padding: '0 24px',
        borderBottom: '1px solid #f0f0f0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}
    >
      {/* 左侧Logo和标题 */}
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div 
          style={{ 
            fontSize: '20px', 
            fontWeight: 'bold',
            color: '#1890ff',
            cursor: 'pointer'
          }}
          onClick={() => navigate('/')}
        >
          百达设计任务协同系统
        </div>
      </div>

      {/* 右侧用户信息 */}
      <Space size="middle">
        {/* 通知按钮 */}
        <Button 
          type="text" 
          icon={<BellOutlined />} 
          size="large"
        />

        {/* 用户信息下拉菜单 */}
        <Dropdown
          menu={{ items: userMenuItems }}
          placement="bottomRight"
          trigger={['click']}
        >
          <div 
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              cursor: 'pointer',
              padding: '4px 8px',
              borderRadius: '6px',
              transition: 'background-color 0.2s',
              minWidth: '120px',
              maxWidth: '200px'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <Avatar 
              src={user?.avatar} 
              icon={<UserOutlined />}
              size="default"
            />
            <div style={{ 
              marginLeft: '8px', 
              textAlign: 'left',
              flex: 1,
              overflow: 'hidden'
            }}>
              <div style={{ 
                fontSize: '14px', 
                fontWeight: '500',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}>
                {user?.realName || user?.username}
              </div>
              <Text 
                type="secondary" 
                style={{ 
                  fontSize: '12px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: 'block'
                }}
              >
                {getRoleText(user?.role)}
              </Text>
            </div>
          </div>
        </Dropdown>
      </Space>
    </Header>
  );
};

export default Navbar;
